import { render, staticRenderFns } from "./ChangeSucceed.vue?vue&type=template&id=1b4bcf42&scoped=true&"
import script from "./ChangeSucceed.vue?vue&type=script&lang=ts&"
export * from "./ChangeSucceed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4bcf42",
  null
  
)

export default component.exports